<!-- version 2021/05/20 -->
<template>
    <div class="d-flex">
        <app-label-text class="mb-0" :title="title"></app-label-text>
        <app-normal-text :text="text"></app-normal-text>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            text: String
        }
    }
</script>

<style lang="sass" scoped>
    label
        min-width: 120px
</style>